module.exports = __webpack_public_path__ + "img/4.4982b2a8.png";